import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import UserStorageUtil from '../../util/UserStorageUtil';
import HmAjax from '../../util/HmAjax';
import $ from 'jquery';


export default class LessonView extends LoggedInPage{
	
	constructor(props) {
		super(props);
		this.state = { "dataLoaded": false, data: {}, lessonUrl:null, iFrameHeight: '0px'}
		this.requestParams = "";
		this.trackId = null;		
		this.trackLessonClose = this.trackLessonClose.bind(this);
		this.trackLessonCloseInICEPIE = this.trackLessonCloseInICEPIE.bind(this);
		this.handleMessage = this.handleMessage.bind(this);
		this.setContentSize = this.setContentSize.bind(this);
		this.resizeCall = this.resizeCall.bind(this);
		this.userId = null;

		this.enableTimer = true;
		this.lessonClosed = false;
		this.currentLanguage = null;
	}

	componentDidMount() {
		this.setState({ loggedIn: true});
		this.getLessonUrl();
		this.trackLessonOpen();
		var me =  this;
		this.currentLanguage = null;
		this.initiateTimer();

		$(window).on('beforeunload', function() {	
			if(me.lessonClosed == false){
				me.lessonClosed = true;
				me.trackLessonClose();
				me.trackLessonCloseInICEPIE();
			}
		});
		$(window).on('unload', function() {
			if(me.lessonClosed == false){
				me.lessonClosed = true;
				me.trackLessonClose();
				me.trackLessonCloseInICEPIE();
			}
		});		
		
		this.userId = this.getUser().getUserId();
		
		window.addEventListener('message', this.handleMessage, false);
		
		$(window).resize(function(){
			me.setContentSize();
		});
		
		this.setContentSize();
	}	
	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.trackLessonClose);
		window.removeEventListener('message', this.handleMessage, false);
	}

	handleMessage(event){	
	  console.log("handlemessage name=="+event.data);
	  let me=this;
	  var data = JSON.parse(event.data)
	  var name = data.name;
	   if(name == "html5UserAction" && data.params){
		let params = data.params;
		if(params && params.action=="languageUpdated"){
			var currentLanguage = null;
			if(this.currentLanguage !=null && (this.currentLanguage.toLowerCase() == params.updatedLanguage.toLowerCase()))
	    	{
	    		console.log("Same Language",this.currentLanguage);
	    	}else{
				this.currentLanguage = params.updatedLanguage;
	    		currentLanguage = this.currentLanguage;

			    if(currentLanguage && currentLanguage.length>0){
			    	console.log("Api called",currentLanguage);
			    	me.trackLessonLanguage(currentLanguage)
			    }	
	    	}
		}

	  }
    }


	setLessonNameAsTitle(lessonId){
		try{
			if(lessonId){
				var title = UserStorageUtil.getStoredSessionItem(lessonId);

				if(!title){
					title = sessionStorage.getItem(lessonId);
				}else{
					title = " " + title + " ";

					if(sessionStorage){
						if(!sessionStorage.getItem(lessonId))
							sessionStorage.setItem(lessonId, title);

						//remove after setting
						UserStorageUtil.deleteSessionItem(lessonId);
					}							
				}

			}


			if(title)
				document.title += title;	
		}catch(e){}
	}


	initiateTimer(){
		var me = this;
		setInterval(() => {
			if(me.enableTimer){
   	 		//console.log("initiateTimer ::");
   	 		me.trackLessonClose();
   	 	}
   	 }, 5000);
	}

	getAdditionalUrlParams(lessonUrl){
		try{
			var paramsArr = window.location.href.split("?");
			if(paramsArr.length > 1 && paramsArr[1].length > 0){
				lessonUrl += "&"+paramsArr[1];

				var paramObj = this.extractParamsObj(paramsArr[1]);

				this.setLessonNameAsTitle(paramObj["url"]);
			   //If it is a new window, else do not change the title
			 /*  if(paramObj["lessonname"] !== undefined && paramObj["lessonname"] !== null && paramObj["lessonname"].length > 0){
			   		try{document.title += " " + decodeURIComponent(paramObj["lessonname"]) + " ";}catch(e){}
			   	}*/

			   }
			}catch(e){}

			return lessonUrl;
		}
		getAllParamsObj(){
			var paramObj = {};
			try{
				var paramsArr = window.location.href.split("?");
				if(paramsArr.length > 1 && paramsArr[1].length > 0){
					paramObj = this.extractParamsObj(paramsArr[1]);			   
				}
			}catch(e){}

			return paramObj;
		}
		getAllUrlParams(urlString){
			try{
				var paramsArr = window.location.href.split("?");
				if(paramsArr.length > 1 && paramsArr[1].length > 0){
					if(urlString.indexOf("?") > 0){
						urlString += "&"+paramsArr[1];
					}else{
						urlString += "?"+paramsArr[1];
					}
				}
			}catch(e){}

			return urlString;
		}

		extractParamsObj(paramsArrStr){
			var paramObj = {};
			try{
				if(paramsArrStr !== null && paramsArrStr.length > 0){
					var paramPairArr = paramsArrStr.split("&");
					if(paramPairArr !== null && paramPairArr.length > 0){
						for(var i=0; i < paramPairArr.length; i++){
							var eachPair = paramPairArr[i].split("=");
							paramObj[eachPair[0]] = (eachPair.length > 0) ? eachPair[1] : eachPair[0];
						}
					}
				}
			}catch(e){}

			return paramObj;
		}

		getLessonUrl(){
			try{
				var me = this;

				var successHandler = function (data) {
					if ((data === null) || (data !== null && data.error)) {
						var buttons = [{
							label: me.rb("go_home"),
							handler: () => { window.location.href = me.getUrlFor("LOGIN_HOME"); }
						}]
						me.showAlert(me.rb(data.testStatus), me.rb(data.reference_id) || me.rb(data.testStatus), buttons);

						return;
					}

					me.setState({ "dataLoaded": true, "data": data, lessonUrl:me.getAdditionalUrlParams(data.lessonUrl)});
				}

				var failureHandler = function (err) {
					var buttons = [{
						label: me.rb("go_home"),
						handler: () => { window.location.href = me.getUrlFor("LOGIN_HOME"); }
					}]
					me.showAlert(me.rb("error"), me.rb("generic_connect_error"), buttons);

					return;
				}
				var lessonId = this.props.match.params.id;

				new HmAjax(this.getAllUrlParams(this.getUrlFor("LESSON_URL")+lessonId)).get(successHandler,failureHandler);
			}catch(e){
				var buttons = [{
					label: me.rb("go_home"),
					handler: () => {window.location.href = me.getUrlFor("LOGIN_HOME");}
				}]
				me.showAlert(me.rb("error"), me.rb("system_error"), buttons);
			}

		}
		trackLessonClose(){
			try{
				var me = this;

				var successHandler = function (data) {
					console.log("track lesson close success");
				}

				var failureHandler = function (err) {
					console.log("Error in TRACK_LESSON_CLOSE");
					return;
				}
				new HmAjax(this.getUrlFor("TRACK_LESSON_CLOSE")+me.trackId+"/"+me.userId).get(successHandler,failureHandler);
			}catch(e){
				console.log("Error in track lessson close..");
			}
		}
		trackLessonCloseInICEPIE(){
			try{
				var params = this.getAllParamsObj();
				var trackObj = {
					"lesson_id": parseInt(params.lessonidTracking)				     
				}

				this.initiateTrack("lesson_closed",trackObj);
			}catch(e){
			}
		}
		trackLessonOpen(){
			var params = this.getAllParamsObj();
		/*lessonPref:"html5"
		lessonname:"Subtracting%207-Digit%20Numbers"
		revisiontopicid:"0"
		src:"plp"
		testid:"0"
		url:"vl1283a_subtract7digit"*/		
		var formData = {
			"lessonUrl" : params.url, 
			"lessonDd" : (params.lessonPref == "flash") ? 0 : (parseInt(params.dd) || 1), 
			"lessonType" : params.lessonPref, 
			"classId" : parseInt(params.classId), 
			"accessId" : parseInt(params.accessId), 
			"topicSubtopicMapId" : parseInt(params.revisiontopicid)
		}
		
		try{
			var me = this;
			var successHandler = function (data) {
				if (data != null) {
					me.trackId = data.trackId;
					return;
				}

			}

			var failureHandler = function (err) {
				console.log("Error in TRACK_LESSON_OPEN");
				return;
			}
			var lessonId = this.props.match.params.id;

			new HmAjax(this.getUrlFor("TRACK_LESSON_OPEN"),formData).post(successHandler,failureHandler);
		}catch(e){
			console.log("Error in lesson tracking...");
		}
		try{
			var trackObj = {
				"lesson_id": parseInt(params.lessonidTracking),
				"lesson_dd": parseInt(params.dd) || 1,
				"source": this.getTracker().enums.lessonSource[params.tracksource],
				"source_id": parseInt(params[params.tracksource == "subtopic" ? "revisiontopicid" : "testid"]),
				"source_question_id": -1    
			}
			
			this.initiateTrack("lesson_opened",trackObj);
		}catch(e){
		}
	}



	trackLessonLanguage = (_currentLanguage) => {
		let currentLanguage = null;
		var params = this.getAllParamsObj();
		var lessonidTracking = null;	
		if(this.trackId){
			lessonidTracking = this.trackId;
		}

		if(lessonidTracking>0 && _currentLanguage && _currentLanguage.length>0){
			currentLanguage = _currentLanguage.toLowerCase()

			var successHandler = function (data) {
				console.log("Success in TRACK_LESSON_LANGUAGE");
			}

			var failureHandler = function (err) {
				console.log("Error in TRACK_LESSON_LANGUAGE");
				return;
			}

			new HmAjax(this.getUrlFor("TRACK_LESSON_LANGUAGE")+lessonidTracking+"&language="+currentLanguage).get(successHandler,failureHandler);
		}
	}

	setContentSize()
	{
		var me = this;
		//
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      		//
      		$("#contentIFrame").css("visibility","hidden");
        	setTimeout(function()
        	{
        		$("#contentIFrame").css("visibility","visible");
        		me.resizeCall();
        	},1000);
        	//
    	}
		me.resizeCall();
	}
	//
	resizeCall()
	{
		
		//
		try
		{
			$("#contentIFrame").css({
				width:window.innerWidth,
				height:window.innerHeight
			});
		}catch(e)
		{
		}
	}
	render() {	
		if(!this.state.dataLoaded || this.state.lessonUrl === null){
			return (<div> {this.showLoader()}</div>);
		}else{
			var me = this;
			return (  
			<div id="lessonIframeContainer" style={{height:"100vh", overflowY:'hidden'}}>
				<iframe 
				id="contentIFrame"
				style={{width:'100%', height:me.state.iFrameHeight, overflowY:'hidden'}}
				onLoad={() => {
					me.setState({
						"iFrameHeight":  (window.innerHeight) + 'px'
					});
				}} 
				ref="iframe" 
				src={this.state.lessonUrl}
				width="100%" 
				height={me.state.iFrameHeight} 
				scrolling="no" 
				frameBorder="0"
				/>
			</div>
			);
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/lesson/LessonView.js